<template>
    <div id="CloudBody">
        <div class="InputSearch">
            <div class="inputContent">
                <input type="search" v-model="value" maxlength="20" v-on:keyup.enter="getList()" placeholder="请输入号码或名字">
               <!-- <van-search :value="value" input-align="center" placeholder="请输入搜索关键词"/> -->
            </div>
            <div class="book" v-if="isShow" v-on:click="openCall()">
                <div>
                <p>高级筛选</p>
                <span></span>
                </div>
            </div>
          <div class="abv">
            <div class="count">
                客人数量：{{counts}}
            </div>
          <!-- <router-link to="Report">
            <div class="shop" v-if="isShow">
                门店客户数量
            </div>
          </router-link> -->
            <div  class="shop" @click="apply">
              <div>合同续约期:</div>
              <van-count-down :time="time" @finish="finish" format="DD 天 HH 时" />
            </div>
         </div>
        </div>
        <div class="bodys" style="height:1000px;">
            <div class="body">
              <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
              <van-list v-model="loading" :finished="finished" finished-text="没有更多了"  @load="onLoad">
                <van-cell v-for="item in dataList" :key="item.id" @click="details(item.id)" >
                    <div class="list" >
                        <div class="list_left">
                            <p class="name">{{item.name}}</p>
                            <p class="tel">{{item.mobile}}</p>
                        </div>
                        <div class="list_right">
                            <p>{{item.store}}</p>
                            <p>备注:{{item.remark | text}}</p>
                            <p class="date">时间：{{item.updatedAt | dateMoment("YYYY-MM-DD HH:mm")}}</p>
                        </div>
                </div>
                </van-cell>
              </van-list>
                <!-- <div class="list" v-for="item in model" :key="item.id">
                    <router-link :to="{path:'/Detail', query:{id:item.id}}">
                        <div class="list_left">
                            <p class="name">{{item.name}}</p>
                            <p class="tel">{{item.mobile}}</p>
                        </div>
                        <div class="list_right">
                            <p>{{item.store}}</p>
                            <p>备注:{{item.remark | text}}</p>
                            <p class="date">时间：{{item.updatedAt | dateMoment("YYYY-MM-DD HH:mm")}}</p>
                        </div>
                    </router-link>
                </div> -->
              </van-pull-refresh>
            </div>
        </div>
        <router-link to="form">
            <div class="add">
                <img src="../../../static/img/add.png">
            </div>
        </router-link>
        <van-popup v-model="show" class="popup" :close-on-click-overlay="false">
            <img class="jinggao" src="./../../../static/img/jinggao.png" alt="">
           <div style="padding:10px 0">
              您的品牌管理费最后期限已过，请及时续费！
           </div>
           <img class="play" src="./../../../static/img/WechatIMG40.jpeg" alt="">
          </van-popup>
    </div>
</template>
<script>
import moment from 'moment';
export default {

    name: 'File',
    data() {
        return {
          time: 30*60*60*1000,
          show:false,
          isDownLoading: false, // 下拉刷新
          loading: false,
          finished: false,
          counts:'',//总条数
          value: "",
          isShow:false,
          dataList: [],
          smodel:[],
          data:{
            keyword:'',
            page:1,
            size:10,
            deptId:''
          }
        }
    },
    methods: {
      apply(){
        window.location.href ='https://mingyuehome.oss-cn-shanghai.aliyuncs.com/WechatIMG40.jpeg'
      },
      finish(){
        this.show = true
      },
      cll(){
        setTimeout(()=>{   //设置延迟执行
          console.log('ok');
      },1000)
      },
      onDownRefresh() {
          localStorage.removeItem('doc')
          this.isDownLoading=false
          this.finished = false
         this.getEventList()
       },
      //手机号查询
      getList(){
        this.data.keyword =this.value
        console.log(' this.value: ',  this.value);
        this.getEventList()

      },
      //获取续费天数
      renewal(){
        let data = {
          deptId:localStorage.getItem('doc')
        }
        this.$http.post('/api/dept/queryTsByDeptId',data).then(res=>{
          let timeStamp = new Date().getTime()
          if(res.data.data.expirationTs ==null){
            let createdAt = new Date(res.data.data.createdAt).getTime()
            this.time = createdAt-timeStamp
          }else{
            this.time = res.data.data.expirationTs- timeStamp
          }
        })
      },
      //获取用户列表
      getEventList(){
        this.data.deptId =localStorage.getItem('doc')
        this.$http.post('/api/member/memberList',this.data).then(res=>{
          if(res.data.errorCode == 100){
            this.finished = false;
            this.loading = false;
             this.dataList = res.data.data.list
             this.counts = res.data.data.count
             if (this.counts <= this.dataList.length) {
               this.finished = true;
            }
          }

        })
      },
      //根据部门查询
    openCall: function() {
      this.$ddapi.departmentsPicker().then(user => {
          localStorage.setItem('doc', user[0].id)
          this.data.deptId =localStorage.getItem('doc')
           this.getEventList()
          // "/api/member/getDeptIds"
        },
        err => {
          alert(JSON.stringify(err));
        }
      );
    },
    //查看详情
    details(ids){
      console.log('ids: ', ids);
       this.$router.push({
        path: '/Detail',
        query: {
          id:ids
        }
      })
    },
    onLoad() {
      setTimeout(() => {
        this.data.size += 5;
        this.getEventList();
      }, 1000);
    },

    },
    created: function () {
        this.renewal()
        this.getEventList();
        let is_sys = localStorage.getItem("is_sys")
       if(is_sys == "true"){
        this.isShow = true
       }else{
         this.isShow = false
       }

    }

}
</script>
<style scoped>
/* .abv{
position: fixed;
width: 100%;
height: 30px;
background: #333;
}

.count{
position: absolute;
top: 270%;
left: 4%;
font-size: 1.3rem;
color: #333;

} */
/* .shop{
    position: absolute;
top: 240%;
right: 4%;
font-size: 1.3rem;
color: #999;
} */
.jinggao{
  width: 60px;
  /* height: 30px; */
}
.play{
  height: 120px;
  /* width: 80px; */
}
.popup{
  border-radius: 5px;
  width: 70%;
  text-align: center;
  font-size: 16px;
   color: #d31d1d ;
   word-wrap:break-word;
   padding: 10px;
}
.van-count-down{
  color: #d31d1d !important;
}
.count{
  padding-top: 15px;
}
.shop{
   padding-top: 15px;
   position: absolute;
   top: 0%;
   right: -28%;
   display: flex;
    color: #d31d1d;

}
.abv{
  display: flex;
  font-size: 14px;;
  position: relative;
  justify-content: space-between;
}
.book {
    position: absolute;
    top: 32%;
    right: 4%;
}

.book {
    color: #CC982B;
    font-size: 1.5rem;
}

.book span {
    position: absolute;
    top: 5%;
    right: -3%;
    display: inline-block;
    border-radius: 50%;
    width: 5px;
    height: 5px;
    border: 1px solid #D31D1D;
    background: #d31d1d;
}

.add {
    position: fixed;
    width: 100%;
    bottom: 2%;
    left: 42%;
}

.add img {
    width: 4.8rem;
}

.date {
    font-size: 1rem;
    color: #919090;
}

.seek {
    border-top: 1px solid #d4d4d4;
}

.InputSearch {
    position: fixed;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    background-color: #f8f8f8;
    padding: 1.6rem 8.2rem 0.5rem 1.2rem;
    box-shadow: 1px 2px 5px 0px #cdcdcd;
    z-index: 2;
}

.inputContent {
    border: 1px #dbdada solid;
    border-radius: 0.3rem;
    padding-right: 1.1rem;
    background-color: #fff;
}

.inputContent input {
    width: 120%;
    text-align: center;
    height: 3rem;
    line-height: 3rem;
    font-size: 1.2rem;
    background-size: 2rem;
    appearance: none;
}

input[type="search"] {
    background: url("./../../../static/img/icon-13.png") left no-repeat;
    background-position: 1.2rem 0.7rem;
    background-size: 1.6rem 1.6rem;
}

.bodys {
    background: #fff;
    border-top: 1px solid #d9d8d8;
    margin-top: 8.5rem;
}

.body {
    /* overflow: scroll; */
    margin: 0rem 2rem;
}

.list {
    border-bottom: 1px solid #f5f5f5;
    display: -webkit-box;
    padding: 1rem 1rem 1rem 1rem;
    background: #fff;
}

.list_left {
    width: 38%;

    border-right: 1px solid #f5f5f5;
    height: 4rem;
}

.name {
    font-size: 1.8rem;
    color: #47AA96;
}

.tel {
    font-size: 1.3rem;
    color: #919090;
}

.list_right {
    width: 150px;
    font-size: 1.3rem;
    margin-left: 10%;
}

#CloudBody {
    height: 100%;
    overflow-y: scroll;
}

</style>





// WEBPACK FOOTER //
// File.vue?2bfe7c59